exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ProjectDetailsModalId .modal-dialog,#ShowRolesModal .modal-dialog{min-width:80%}.StickeyPanel{position:sticky;top:130px}.StickeyPanelModal{position:sticky;top:15px}.StickeyEmployeelModal{position:sticky;top:5px}", ""]);

// exports
